export type ChunkEntry = [string[], Record<string, Function>, Function?];

export type RuntimeShim = {
  processChunk: (chunk: ChunkEntry) => void;
  setSharedModules: (shared: Record<string, unknown>) => void;
};

export const RESOLVE_MODULE = 1;
export const CACHE_NAMESPACE = 2;
export const ES_MODULE_PASSTHROUGH = 4;
export const RAW_VALUE = 8;
export const THENABLE_PASSTHROUGH = 16;
